<template>
    <nav class="topnav">
        <a href="#top" class="topnav-logo">
            <img src="/assets/logo-blue.svg" alt="One Broadband">
        </a>
        <div class="topnav-links">
            <a href="#technology">Technology</a>
            <a href="#offer">Offerings</a>
            <a href="#about">About us</a>
            <a href="#loyalty">Loyalty</a>
            <a :href="COVERAGE_URL" target="_blank" rel="noopener">Coverage ↗</a>
            <ObButton href="#contact" variant="primary" size="md">Get connected</ObButton>
        </div>
    </nav>
</template>

<script lang="ts" setup>
    import ObButton from '@/components/ObButton.vue'
    import { COVERAGE_URL } from '@/data/content'
</script>

<style scoped>
    .topnav {
        position: sticky;
        top: 0;
        z-index: 60;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 24px;
        padding: 0 44px;
        min-height: 78px;
        flex-wrap: wrap;
        row-gap: 10px;
        background: var(--ob-nav-bg);
        backdrop-filter: blur(18px);
        -webkit-backdrop-filter: blur(18px);
        border-bottom: 1px solid var(--ob-navy-a09);
    }
    .topnav-logo { display: flex; align-items: center; }
    .topnav-logo img { height: 29px; display: block; }
    .topnav-links {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 12px 22px;
        font-size: 14.5px;
        font-weight: 500;
    }
    .topnav-links > a:not(.ob-btn) {
        color: var(--ob-ink-soft);
        white-space: nowrap;
        text-decoration: none;
    }

    @media (max-width: 700px) {
        /* blur on sticky chrome lags on iOS — solid bg on mobile */
        .topnav { padding: 10px 20px; min-height: 0; backdrop-filter: none; -webkit-backdrop-filter: none; background: var(--ob-strip-bg-solid); }
        .topnav-logo img { height: 24px; }
        .topnav-links { gap: 8px 14px; font-size: 13.5px; justify-content: flex-end; }
    }
</style>
